module.exports = __webpack_public_path__ + "media/images/pokerroom/fulltilt/step3-24a4692162c96f93382ad33f9ca0cc71.jpg";